import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=f25d0656&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f25d0656')) {
      api.createRecord('f25d0656', component.options)
    } else {
      api.reload('f25d0656', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=f25d0656&", function () {
      api.rerender('f25d0656', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28bm7pFb5xAJg/JS/cancellationPolicy.vue"
export default component.exports